export const getProjectLogisticFormRules = ({ isCheckbox }: { isCheckbox: boolean }) => {
  return isCheckbox ? undefined : [{ required: true }];
};
